import { ClipLoader } from "react-spinners";

const PrimaryButton = ({
  text = "",
  type = "button",
  className = "",
  primaryClassName = "btn btn-primary",
  iconClassName = "",
  icon = "",
  handleClick,
  disabled,
  loading = false,
  buttonId = "",
}) => {
  return (
    <button
      id={buttonId}
      type={type}
      className={`${primaryClassName} ${className}`}
      onClick={handleClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <ClipLoader color="#fff" size={20} aria-label="Loading Spinner" />
      ) : (
        text
      )}
      {!loading && icon && (
        <img alt="icon" src={icon} className={iconClassName + " ml-2"} />
      )}
    </button>
  );
};

export default PrimaryButton;
